export default "__VITE_ASSET__DIDEyDx5__"